export const isValidHttpUrl = (urlText: string) => {
  let url: URL;

  try {
    url = new URL(urlText);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};
